import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Service Category Name',
    field: 'serviceCategoryName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service Category Code',
    field: 'serviceCategoryCode',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Division',
    field: 'division',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    searchable: true,
  },
];
